import { inject, Injectable } from '@angular/core';
import { SimpleApi } from '@core/api/simple.api';
import { TableDatasource } from '@core/api/table.datasource';
import { OpkraevningUdestaaendeSearchParams } from './opkraevning-udestaaende-search/opkraevning-udestaaende-search-params.model';
import { RisikoOpkraevningUdestaaende } from './risiko-opkraevning-udestaaende.model';

@Injectable({
  providedIn: 'root',
})
export class OpkraevningUdestaaendeDatasource extends TableDatasource<
  RisikoOpkraevningUdestaaende,
  OpkraevningUdestaaendeSearchParams
> {
  endpoint = '/api/admin/risikoopkraevningudestaaender';
  defaultSortField = 'id';

  simpleApi = inject(SimpleApi);
}
